import { render, staticRenderFns } from "./SwiperIframe.vue?vue&type=template&id=e2471928&"
import script from "./SwiperIframe.vue?vue&type=script&lang=js&"
export * from "./SwiperIframe.vue?vue&type=script&lang=js&"
import style0 from "./SwiperIframe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2471928')) {
      api.createRecord('e2471928', component.options)
    } else {
      api.reload('e2471928', component.options)
    }
    module.hot.accept("./SwiperIframe.vue?vue&type=template&id=e2471928&", function () {
      api.rerender('e2471928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SwiperIframe.vue"
export default component.exports